/**
 * Fiche produit (KM Matériaux) :
 * 1. Popup demande de devis — ouverture/fermeture (boutons data-km-devis-open /
 *    data-km-devis-close, overlay, Échap), scroll de page gelé pendant l'ouverture.
 * 2. Galerie — clic sur une miniature = elle devient l'image principale (le
 *    zoom lightbox reste géré globalement par pdw_lightbox sur .pdw-lightbox a).
 */
document.addEventListener('DOMContentLoaded', () => {

    // ----- Popup devis -----
    const modal = document.getElementById('km-modal-devis');
    if (modal) {
        const open = () => {
            modal.hidden = false;
            requestAnimationFrame(() => modal.classList.add('is-open'));
            document.body.style.overflow = 'hidden';
            modal.querySelector('input, textarea, select, button:not([data-km-devis-close])')?.focus?.();
        };
        const close = () => {
            modal.classList.remove('is-open');
            document.body.style.overflow = '';
            setTimeout(() => { modal.hidden = true; }, 250); // laisse finir le fondu
        };

        document.querySelectorAll('[data-km-devis-open]').forEach((btn) => {
            btn.addEventListener('click', open);
        });
        modal.querySelectorAll('[data-km-devis-close]').forEach((el) => {
            el.addEventListener('click', close);
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && !modal.hidden) close();
        });
    }

    // ----- Galerie : miniature → image principale -----
    const mainLink = document.querySelector('.km-produit__gallery-main');
    const mainImg = mainLink?.querySelector('img');
    document.querySelectorAll('[data-km-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', (e) => {
            // 1er thumb déjà affiché en grand → laisser la lightbox s'ouvrir ;
            // sinon le clic SWAPPE l'image principale (pas de zoom direct)
            if (thumb.classList.contains('is-active')) return;
            e.preventDefault();
            if (!mainImg) return;
            mainImg.src = thumb.dataset.large;
            mainImg.removeAttribute('srcset');
            mainLink.href = thumb.href; // le zoom de la grande image suit
            document.querySelectorAll('[data-km-thumb].is-active').forEach((t) => t.classList.remove('is-active'));
            thumb.classList.add('is-active');
        });
    });
});
